// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"37033b38","264":"22df716c","295":"0d71fcd8"}[chunkId] + ".chunk.js";
};